import { render, staticRenderFns } from "./em-create-salesteamlead.vue?vue&type=template&id=c80d6368&scoped=true&"
import script from "./em-create-salesteamlead.vue?vue&type=script&lang=js&"
export * from "./em-create-salesteamlead.vue?vue&type=script&lang=js&"
import style0 from "./em-create-salesteamlead.vue?vue&type=style&index=0&id=c80d6368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80d6368",
  null
  
)

export default component.exports